import { Stack } from "@mui/material";
import { ExternalLink, Text } from "@src/lib/ui-react";
import { SHIFT_INVITE_CUSTOM_RATE_LABEL } from "./constants";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useShiftInviteContext } from "./Context/shiftInviteContext";
import { useSupportArticles } from "@src/appV2/HelpCenter/api/useSupportArticles";
import { findSupportArticleUrlById } from "@src/appV2/HelpCenter/utils";
interface ShiftInviteCustomRateNoAccessBannerProps {
  workplaceId: string;
  workplaceUserId: string;
}

export function ShiftInviteCustomRateNoAccessBanner(
  props: ShiftInviteCustomRateNoAccessBannerProps
) {
  const { addUserJourneyEvent } = useShiftInviteContext();
  const { data: supportArticlesData } = useSupportArticles();
  const supportArticleUrl = findSupportArticleUrlById(
    supportArticlesData,
    "custom-rates-for-shift-invites-faq"
  );
  const SHIFT_INVITE_CUSTOM_RATE_NO_ACCESS_BANNER = "Shift Invite Custom Rate No Access Banner";
  return (
    <Stack spacing={0.5}>
      <Text bold>{SHIFT_INVITE_CUSTOM_RATE_LABEL}</Text>

      <Text
        variant="subtitle2"
        color={(theme) => theme.palette.text.secondary}
        sx={{
          // This causes the text to wrap once it reaches the end of the container,
          //   instead of causing the container's width to expand.
          maxWidth: 0,
          minWidth: "100%",
        }}
      >
        You are unable to adjust rates for shift invites due to the permission settings at your
        workplace. Please reach out to your administrator or corporate contact to discuss{" "}
        {supportArticleUrl ? (
          <ExternalLink
            to={supportArticleUrl}
            underline="hover"
            onClick={() => {
              addUserJourneyEvent("click", SHIFT_INVITE_CUSTOM_RATE_NO_ACCESS_BANNER);
              logEvent(APP_V2_USER_EVENTS.SHIFT_INVITE_CUSTOM_RATE_SUPPORT_LINK_CLICKED, {
                ...props,
                createdAt: new Date(),
              });
            }}
          >
            access
          </ExternalLink>
        ) : (
          "access"
        )}{" "}
        to this feature.
      </Text>
    </Stack>
  );
}
